module.exports = __webpack_public_path__ + "img/overtime-icon.ac3a0ac7.png";